// frontend/src/contexts/ThemeContext.js
// ============================================================================
// THEME CONTEXT PARTAGÉ — HoraPilot Admin Center
// Importé par le SuperAdminDashboard (provider) et les composants enfants
// ============================================================================

import { createContext, useContext } from 'react';

// ============================================================================
// PALETTES
// ============================================================================
export const THEMES = {
  light: {
    mode: 'light',

    // Surfaces
    bg:              '#f3f5f7',
    bgSidebar:       '#ffffff',
    bgCard:          '#ffffff',
    bgCardHover:     '#f9fafb',
    bgInput:         '#f5f7f9',
    bgInputFocus:    '#ffffff',
    bgTableHeader:   '#f8f9fb',
    bgTableRowHover: '#f5f8fa',
    bgStatusBar:     '#ffffff',
    bgOverlay:       'rgba(0,0,0,0.4)',

    // Borders
    border:          '#e2e6ea',
    borderLight:     '#edf0f3',
    borderActive:    '#448696',

    // Text
    text:            '#1a1f26',
    textSecondary:   '#5a6370',
    textMuted:       '#9ca3ae',
    textInverse:     '#ffffff',

    // Brand
    primary:         '#448696',
    primaryDark:     '#6a9fad',
    primarySoft:     'rgba(136, 185, 197, 0.10)',
    primarySofter:   'rgba(136, 185, 197, 0.05)',
    primaryBorder:   'rgba(136, 185, 197, 0.25)',
    primaryText:     '#5a8f9c',

    // Semantic
    success:         '#16a34a',
    successSoft:     'rgba(22, 163, 74, 0.08)',
    successText:     '#15803d',
    warning:         '#d97706',
    warningSoft:     'rgba(217, 119, 6, 0.08)',
    warningText:     '#b45309',
    danger:          '#dc2626',
    dangerSoft:      'rgba(220, 38, 38, 0.06)',
    dangerText:      '#dc2626',

    // Effects
    shadow:          '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
    shadowLg:        '0 4px 12px rgba(0,0,0,0.08)',
    scrollThumb:     'rgba(0,0,0,0.12)',
    scrollThumbHover:'rgba(0,0,0,0.20)',
  },

  dark: {
    mode: 'dark',

    bg:              '#0c1017',
    bgSidebar:       '#080c12',
    bgCard:          'rgba(255,255,255,0.025)',
    bgCardHover:     'rgba(255,255,255,0.05)',
    bgInput:         'rgba(255,255,255,0.035)',
    bgInputFocus:    'rgba(255,255,255,0.06)',
    bgTableHeader:   'rgba(255,255,255,0.025)',
    bgTableRowHover: 'rgba(255,255,255,0.035)',
    bgStatusBar:     '#080c12',
    bgOverlay:       'rgba(0,0,0,0.6)',

    border:          'rgba(255,255,255,0.07)',
    borderLight:     'rgba(255,255,255,0.04)',
    borderActive:    'rgba(136, 185, 197, 0.4)',

    text:            '#e2e6ea',
    textSecondary:   '#8b929c',
    textMuted:       '#555d68',
    textInverse:     '#0c1017',

    primary:         '#448696',
    primaryDark:     '#a0cdd8',
    primarySoft:     'rgba(136, 185, 197, 0.10)',
    primarySofter:   'rgba(136, 185, 197, 0.04)',
    primaryBorder:   'rgba(136, 185, 197, 0.20)',
    primaryText:     '#448696',

    success:         '#34d399',
    successSoft:     'rgba(52, 211, 153, 0.08)',
    successText:     '#34d399',
    warning:         '#fbbf24',
    warningSoft:     'rgba(251, 191, 36, 0.08)',
    warningText:     '#fbbf24',
    danger:          '#f87171',
    dangerSoft:      'rgba(248, 113, 113, 0.08)',
    dangerText:      '#f87171',

    shadow:          '0 1px 3px rgba(0,0,0,0.3)',
    shadowLg:        '0 4px 16px rgba(0,0,0,0.5)',
    scrollThumb:     'rgba(255,255,255,0.08)',
    scrollThumbHover:'rgba(255,255,255,0.14)',
  }
};

// ============================================================================
// CONTEXT + HOOK
// ============================================================================
export const ThemeContext = createContext(THEMES.light);

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  return ctx || THEMES.light;
};

export default ThemeContext;